import { combineReducers } from 'redux'
import detalleVenta from './detalleVenta'
import solicitudCancelar from './solicitudCancelar';
import cancelaVenta from './cancelaVenta';

export default combineReducers({
    detalleVenta,
    solicitudCancelar,
    cancelaVenta
});